import { render, staticRenderFns } from "./pixel-card.vue?vue&type=template&id=f8c444b0&scoped=true&"
import script from "./pixel-card.vue?vue&type=script&lang=js&"
export * from "./pixel-card.vue?vue&type=script&lang=js&"
import style0 from "./pixel-card.vue?vue&type=style&index=0&id=f8c444b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c444b0",
  null
  
)

export default component.exports